export default __webpack_public_path__ + "static/media/flyering.37888911.svg";